import { useCallback, useEffect, useState } from 'react';
import { AiQuota, getAiQuota } from '../services/aiQuotaService';
import { onAiQuotaChange } from '../utils/aiQuotaEvents';

/** Today's AI quota; reloads after every AI call (utils/aiQuotaEvents). null until loaded or on error. */
export function useAiQuota() {
  const [quota, setQuota] = useState<AiQuota | null>(null);

  const reload = useCallback(async () => {
    try {
      setQuota(await getAiQuota());
    } catch {
      // Not worth an error report: the widgets keep the last value (or stay hidden)
    }
  }, []);

  useEffect(() => {
    reload();
    let timer: number | undefined;
    const unsubscribe = onAiQuotaChange(() => {
      window.clearTimeout(timer);
      timer = window.setTimeout(reload, 300);
    });
    return () => {
      unsubscribe();
      window.clearTimeout(timer);
    };
  }, [reload]);

  return { quota, reload };
}
